import { param } from "@/utils/url/param";

export const API_URL = "/index.php";

export function getApi(ctx) {
    const { rootState, commit, state, dispatch } = ctx;
    const { authToken: token } = rootState;

    const root = API_URL;
    return {
        root,
        rootState,
        state,
        token,
        commit,
        dispatch,
        url: (action, params = {}) => {
            const paramsString = param(params);
            return `${root}?r=${action}&auth_key=${token}&${paramsString}`;
        },
    };
}

export function getPagination(headers) {
    const currentPage = +headers["x-pagination-current-page"];
    const pageCount = +headers["x-pagination-page-count"];
    const itemsPerPage = +headers["x-pagination-per-page"];
    const totalCount = +headers["x-pagination-total-count"];

    return {
        currentPage,
        pageCount,
        itemsPerPage,
        totalCount,
    };
}
